import { useNavigate } from '@tanstack/react-router';

import { AppLayoutContainer } from '../AppLayout';
import { Routes } from '../../../services/Navigation/Routes';

import { NotFound } from './NotFound';

export function NotFoundPageContainer() {
  const navigate = useNavigate();
  const handleHomeButtonClick = () => {
    return navigate({ to: Routes.landing.path });
  };

  return (
    <AppLayoutContainer>
      <NotFound onHomeButtonClick={handleHomeButtonClick} />
    </AppLayoutContainer>
  );
}
